import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { LiveMetrics } from "../components/LiveMetrics";
import { FortressLogo } from "../components/FortressLogo";

export const Landing = () => {
  return (
    <div className="relative overflow-hidden">
      {/* Background Glow */}
      <div className="absolute top-0 -left-40 w-96 h-96 bg-fortress-gold opacity-10 rounded-full blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 min-h-screen flex flex-col justify-center">
        {/* Hero Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          <FortressLogo />

          <h1 className="font-display text-5xl md:text-7xl font-bold text-white mt-6 leading-tight">
            Fortress<span className="text-fortress-gold">Nation</span>
          </h1>

          <p className="font-display text-xl md:text-2xl text-gray-300 mt-4 max-w-3xl mx-auto">
            A Sovereign Digital Economy. Built by brothers. Guarded by code.
          </p>

          <p className="text-gray-400 mt-2 max-w-2xl mx-auto">
            Exploiting inefficiencies. Funding freedom. For the builders, the dreamers, and the ones who refuse to bow.
          </p>

          <div className="mt-8 flex flex-wrap justify-center gap-4">
            <Link 
              to="/dashboard"
              className="bg-fortress-gold text-fortress-midnight px-8 py-3 rounded-lg font-bold hover:scale-105 transition-all shadow-lg shadow-fortress-gold/20"
            >
              Join the Nation
            </Link>

            <button className="border border-gray-600 px-8 py-3 rounded-lg hover:bg-white/10 transition-all">
              The Legend
            </button>
          </div>
        </motion.div>

        {/* Live Metrics */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.8 }}
          className="mt-16"
        >
          <LiveMetrics />
        </motion.div>

        {/* The Legend Teaser */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          className="mt-12 text-center text-gray-400 text-sm border-t border-gray-800 pt-8"
        >
          <p className="font-mono">
            <span className="text-fortress-gold">✧</span> Built in Durban. Powered by Gnosis.{" "}
            <span className="text-fortress-gold">✧</span>
          </p>
        </motion.div>
      </div>
    </div>
  );
};